import cn from "app/utils/classnames";

interface CaptionProps {
  wordToSpell: string;
  sentence: string;
  spelled: boolean;
  correct: boolean;
  onClick?: () => void;
  className?: string;
}

// The caption that appears underneath the video. The wordToSpell is
// automatically omitted.
export default function Caption(props: CaptionProps) {
  // Strip any surrounding quotation marks that were added in the CMS.
  const sentence = props.sentence.replace(/^["']|["']$/g, "");

  // Split the sentence into individual words.
  // Separate punctuation, but include it.
  const captionWords = sentence
    .split(/\s+/)
    .flatMap((word) =>
      word.split(/(?=[.,!?;:])|(?<=[.,!?;:])/).filter(Boolean),
    );

  return (
    <div
      className={cn(
        "italic text-sm",
        "flex flex-wrap justify-center items-baseline content-start gap-0 whitespace-pre-wrap",
        "overflow-y-auto",
        props.className,
      )}
    >
      <span>"</span>
      {captionWords.map((captionWord, i) => {
        if (
          captionWord === props.wordToSpell ||
          captionWord === props.wordToSpell.toLowerCase()
        ) {
          return props.spelled ? (
            <span key={i} className="relative flex">
              <span
                className={cn(
                  props.correct ? "bg-correct" : "bg-incorrect",
                  "opacity-30",
                  "rounded-sm",
                  "absolute top-0 bottom-0 left-0.5 right-0",
                )}
              />
              <span
                className={cn(
                  props.correct ? "bg-correct" : "bg-incorrect",
                  "opacity-30",
                  "rounded-sm",
                  "animate-correct-ping",
                  "absolute top-0 bottom-0 left-0.5 right-0",
                )}
              />
              <span className="font-semibold"> {captionWord}</span>
            </span>
          ) : (
            <button
              key={i}
              onClick={props.onClick}
              className={cn("w-17 h-4", "relative", "flex", "cursor-pointer")}
            >
              <span
                className={cn(
                  "absolute top-0 left-1 right-1 -bottom-1",
                  "border border-amber-400",
                  "bg-amber-100",
                )}
              />
              <span
                className={cn(
                  "absolute top-0 left-1 right-1 -bottom-1",
                  "animate-mild-ping",
                  "bg-amber-200",
                )}
              />
            </button>
          );
        } else {
          const isPunctuation = /^[.,!?;:]$/.test(captionWord);
          return (
            <span key={i}>
              {(i === 0 || isPunctuation ? "" : " ") + captionWord}
            </span>
          );
        }
      })}
      <span>"</span>
    </div>
  );
}
